import React from 'react';
import DynamicForm from '../../components/DynamicForm/DynamicForm';
import {getStoredData} from "../../JsonFiles/fetchData";

const AddBlogPage = () => {
  const totalData = getStoredData();
  const fields = totalData ? totalData["11"].AdminBlog : {};
  const apiUrl = 'https://shahbad-enterprises-backend.vercel.app/blog'; // API endpoint for creating product
  const successRedirect = '/admin/blog'; // Redirect after successful product creation

  return (
    <div>
      <DynamicForm fields={fields} apiUrl={apiUrl} successRedirect={successRedirect} />
    </div>
  );
};


export default AddBlogPage;